/**
 * A/B Test: Ultra Family Pack (6) bundle visibility
 *
 * Test A (control): hide bundle — body[data-family-pack-bundle-ab="false"]
 * Test B (variant): show bundle — body[data-family-pack-bundle-ab="true"]
 *
 * IntelliGems (or manual testing) sets the attribute on <body>.
 */
(function () {
  'use strict';

  if (window.__selluxeFamilyPackBundleAbTestInit) return;
  window.__selluxeFamilyPackBundleAbTestInit = true;

  var BODY_ATTR = 'data-family-pack-bundle-ab';
  var HIDE_LABELS = ['Ultra Family Pack (6)'];
  var HIDDEN_ATTR = 'data-selluxe-hidden-bundle';
  var bundleTimer = null;
  var attrTimer = null;
  var busy = false;

  function normalize(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function shouldHideLabel(text) {
    var normalized = normalize(text);
    var i;

    for (i = 0; i < HIDE_LABELS.length; i++) {
      if (normalized.indexOf(HIDE_LABELS[i]) > -1) return true;
    }

    return false;
  }

  function shouldShowBundle() {
    var body = document.body;
    if (!body) return false;
    return body.getAttribute(BODY_ATTR) === 'true';
  }

  function getBarLabel(bar) {
    var title =
      bar.querySelector('.kaching-bundles__bar-title') ||
      bar.querySelector('[class*="bar-title"]') ||
      bar.querySelector('[class*="bar-name"]') ||
      bar.querySelector('label') ||
      null;

    return normalize(title ? title.textContent : bar.textContent);
  }

  function isBarSelected(bar) {
    if (!bar) return false;

    if (
      bar.classList.contains('kaching-bundles__bar--selected') ||
      bar.getAttribute('aria-checked') === 'true'
    ) {
      return true;
    }

    var radio = bar.querySelector('input[type="radio"]');
    return !!(radio && radio.checked);
  }

  function selectFirstVisibleBar(container) {
    var bars = container.querySelectorAll('.kaching-bundles__bar, [class*="kaching-bundles__bar"]');
    var i;
    var bar;
    var radio;

    for (i = 0; i < bars.length; i++) {
      bar = bars[i];
      if (bar.getAttribute(HIDDEN_ATTR)) continue;
      if (bar.style.display === 'none') continue;
      if (bar.closest('[' + HIDDEN_ATTR + ']')) continue;

      radio = bar.querySelector('input[type="radio"]');
      if (!radio || radio.disabled) continue;

      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      bar.click();
      return;
    }
  }

  function hideBar(bar) {
    if (!bar || bar.getAttribute(HIDDEN_ATTR)) return;

    var wasSelected = isBarSelected(bar);
    var container =
      bar.closest('kaching-bundles-block') ||
      bar.closest('kaching-bundle') ||
      bar.closest('[class*="kaching-bundles"]') ||
      bar.parentElement;

    bar.setAttribute(HIDDEN_ATTR, 'true');
    bar.style.display = 'none';
    bar.setAttribute('aria-hidden', 'true');

    var radio = bar.querySelector('input[type="radio"]');
    if (radio) {
      radio.checked = false;
      radio.disabled = true;
      radio.tabIndex = -1;
    }

    if (wasSelected && container) {
      selectFirstVisibleBar(container);
    }
  }

  function showBar(bar) {
    if (!bar) return;

    bar.removeAttribute(HIDDEN_ATTR);
    bar.style.display = '';
    bar.removeAttribute('aria-hidden');

    var radio = bar.querySelector('input[type="radio"]');
    if (radio) {
      radio.disabled = false;
      radio.tabIndex = 0;
    }
  }

  function findBundleBars() {
    return document.querySelectorAll('.kaching-bundles__bar');
  }

  function processBundles() {
    if (busy) return;
    busy = true;

    try {
      var showBundle = shouldShowBundle();
      var bars = findBundleBars();
      var i;
      var bar;
      var label;

      for (i = 0; i < bars.length; i++) {
        bar = bars[i];
        label = getBarLabel(bar);

        if (!shouldHideLabel(label)) continue;

        if (showBundle) {
          showBar(bar);
        } else {
          hideBar(bar);
        }
      }
    } finally {
      busy = false;
    }
  }

  function scheduleProcessBundles() {
    clearTimeout(bundleTimer);
    bundleTimer = setTimeout(processBundles, 50);
  }

  function watchBodyAttribute() {
    if (!document.body || !window.MutationObserver) return;

    new MutationObserver(function () {
      clearTimeout(attrTimer);
      attrTimer = setTimeout(processBundles, 50);
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR]
    });
  }

  function watchBundleInjection() {
    if (!document.body || !window.MutationObserver) return;

    new MutationObserver(function () {
      scheduleProcessBundles();
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    processBundles();
    watchBodyAttribute();
    watchBundleInjection();

    setTimeout(processBundles, 400);
    setTimeout(processBundles, 1200);
    setTimeout(processBundles, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', scheduleProcessBundles);
})();
